export enum ProfessionalSuitabilityType {
  HospitalExperience = 'hospital_experience',
  IntensiveCareExperience = 'intensive_care_experience',
  IntensiveOrVentilationCertificate = 'intensive_or_ventilation_certificate',
  OperatingRoomExperience = 'operating_room_experience',
  PediatricExperience = 'pediatric_experience',
  DialysisExperience = 'dialysis_experience',
  PostQualificationExperience = 'post_qualification_experience',
  PdlWithAdvancedTraining = 'pdl_with_advanced_training',
  PdlWithLeadershipExperience = 'pdl_with_leadership_experience',
}

export const PROFESSIONAL_SUITABILITY_TYPE = [
  ProfessionalSuitabilityType.HospitalExperience,
  ProfessionalSuitabilityType.IntensiveCareExperience,
  ProfessionalSuitabilityType.IntensiveOrVentilationCertificate,
  ProfessionalSuitabilityType.OperatingRoomExperience,
  ProfessionalSuitabilityType.PediatricExperience,
  ProfessionalSuitabilityType.DialysisExperience,
  ProfessionalSuitabilityType.PostQualificationExperience,
  ProfessionalSuitabilityType.PdlWithAdvancedTraining,
  ProfessionalSuitabilityType.PdlWithLeadershipExperience,
];

export const PROFESSIONAL_SUITABILITY_TYPE_TRANSLATIONS = {
  [ProfessionalSuitabilityType.HospitalExperience]: 'Klinikerfahrung',
  [ProfessionalSuitabilityType.IntensiveCareExperience]: 'Intensivpflegeerfahrung',
  [ProfessionalSuitabilityType.IntensiveOrVentilationCertificate]: 'Intensivweiterbildung/Beatmungsschein',
  [ProfessionalSuitabilityType.OperatingRoomExperience]: 'OP-Erfahrung',
  [ProfessionalSuitabilityType.PediatricExperience]: 'Pädiatrieerfahrung',
  [ProfessionalSuitabilityType.DialysisExperience]: 'Dialyseerfahrung',
  [ProfessionalSuitabilityType.PostQualificationExperience]: 'mehrjährige Berufserfahrung nach der Ausbildung',
  [ProfessionalSuitabilityType.PdlWithAdvancedTraining]: 'PDL nur mit Weiterbildung',
  [ProfessionalSuitabilityType.PdlWithLeadershipExperience]: 'PDL nur mit Führungserfahrung',
};
